import { takeLatest } from 'redux-saga/effects';

import { fetchDashboardModelsLiteAsync } from './dashboard-models-saga';
import { fetchPartnerBrokerAsync } from './partner-broker-saga';
import { DASHBOARD_LITE_MODELS_ACTION_TYPES, DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES } from '@constants/actionTypes/dashboardLiteActionTypes';

export default function* () {
    yield takeLatest(DASHBOARD_LITE_MODELS_ACTION_TYPES.FETCH_DASHBOARD_MODELS_START, fetchDashboardModelsLiteAsync);
    yield takeLatest(DASHBOARD_LITE_PARTNER_BROKER_ACTION_TYPES.FETCH_PARTNER_BROKER_START, fetchPartnerBrokerAsync);
}